import { SceneMeta } from './models/scene-meta.interface';
import { ScenePathEnum } from './models/scene-path.enum';

export const sceneMeta: { [key: string]: SceneMeta } = {
  precisionCutting: {
    identifier: '29184a66-cbba-4d71-9859-b1906e372d17',
    path: ScenePathEnum.precisionCutting,
  },
  ligatingLoop: {
    identifier: '3f83544a-bb44-4fb2-950c-b3f07ed6a9e9',
    path: ScenePathEnum.ligatingLoop,
  },
  pegTransfer: {
    identifier: '73d07b70-c5f1-4af3-bced-6b79b15eeb63',
    path: ScenePathEnum.pegTransfer,
  },
  intracorporealKnot: {
    identifier: 'a7d4b1ac-e4cc-4458-98b8-ad87156bb6dd',
    path: ScenePathEnum.intracorporealKnot,
  },
  extracorporealKnot: {
    identifier: 'b788d589-4136-4e90-9172-3aa201096502',
    path: ScenePathEnum.extracorporealKnot,
  },
  stratafix: {
    identifier: '4950f801-e7f1-42e8-a11a-b6e9738d0419',
    path: ScenePathEnum.stratafix,
  },
};
